import delay from "@/utils/delay";
import "./style.css";

export default class TechnologyNavigator {
  static selector = ".technology-navigator";

  constructor(block) {
    this.block = block;
    this.progressBar = null;
    this.links = [];
    this.titles = [];
    this.subtitles = [];
    this.path = [];
    this.renderedPath = [];
  }

  getTechnologiesOptions = () => {
    const options = [];

    if (this.path.length === 1) {
      (this.technologies[this.path[0]].paths || [])
        .map((p) => p["second_level_technology"])
        // make unique
        .filter(
          (technologyId, index, self) =>
            index === self.findIndex((t) => t === technologyId)
        )
        .forEach((technologyId) => {
          const technology = this.technologies[technologyId];

          if (technology) {
            options.push(technology);
          }
        });
    } else if (this.path.length === 2) {
      (this.technologies[this.path[0]].paths || [])
        .filter((p) => p["second_level_technology"] === this.path[1])
        .map((p) => p["third_level_technology"])
        // make unique
        .filter(
          (technologyId, index, self) =>
            index === self.findIndex((t) => t === technologyId)
        )
        .forEach((technologyId) => {
          const technology = this.technologies[technologyId];

          if (technology) {
            options.push(technology);
          }
        });
    }

    return options;
  };

  updateUrl = () => {
    let slugifiedPath =
      "/technologies/" +
      this.path
        .map((id) => this.technologies[id]?.slug ?? null)
        .filter((slug) => !!slug)
        .join("/");

    if (this.path.length > 2) {
      // get all the fourth level techs in the path
      const fourthLevelTechnologies = this.technologies[this.path[0]].paths
        .filter((p) => p["third_level_technology"] === this.path[2])
        .map((p) => p["fourth_level_technology"])
        // make unique
        .filter(
          (technologyId, index, self) =>
            index === self.findIndex((t) => t === technologyId) &&
            !!this.technologies[technologyId]
        );

      slugifiedPath +=
        "/" +
        this.technologies[
          fourthLevelTechnologies[fourthLevelTechnologies.length - 1]
        ].slug;

      window.App.navigateTo(
        slugifiedPath,
        ".technology-page__navigator-results"
      );
    } else {
      window.App.fakeNavigateTo(slugifiedPath);
    }
  };

  handleItemRadioChange = () => {
    const radios = Array.from(document.getElementsByName("technology"));

    this.selectedItem = radios.find((radio) => radio.checked)?.value ?? null;

    this.render();
  };

  handleBack = async () => {
    if (this.renderedPath.length > 0) {
      const lastSelectedId = this.renderedPath[this.renderedPath.length - 1];

      this.path = this.renderedPath.slice(0, -1);
      await this.render();

      this.selectedItem = lastSelectedId;
      const radios = Array.from(document.getElementsByName("technology"));
      if (radios.length) {
        const radio = radios.find(
          (radio) => parseInt(radio.value, 10) === this.selectedItem
        );

        if (radio) {
          radio.checked = true;
          this.selectorContinueAction.disabled = !this.selectedItem;
        }
      }

      this.updateUrl();
    }
  };
  handleContinue = async () => {
    if (this.selectedItem) {
      this.path.push(parseInt(this.selectedItem, 10));
      await this.render();
      this.updateUrl();
    }
  };
  handleRingItemClick = async (e) => {
    const item = e.currentTarget;
    const technologyId = parseInt(item.dataset.id, 10);

    if (technologyId) {
      this.path.push(technologyId);
      await this.render();
      this.updateUrl();
    }
  };

  handleLinkClick = (e) => {
    const link = e.currentTarget;

    // remove active state on previous items
    Array.from(
      this.block.querySelectorAll(".technology-navigator__item--active")
    ).forEach((i) => i.classList.remove("technology-navigator__item--active"));

    link
      .closest(".technology-navigator__item")
      .classList.add("technology-navigator__item--active");
  };

  destroyItem = (item) => {
    // remove event handlers
    const radio = item.querySelector(
      ".technology-navigator__selector-item-radio"
    );

    if (radio) {
      radio.removeEventListener("change", this.handleItemRadioChange);
    }

    // remove from DOM
    item.remove();
  };

  render = async () => {
    if (this.renderedPath.join("/") !== this.path.join("/")) {
      // fade out this.selector
      this.ringSelector.classList.add("technology-ring-selector--updating");
      this.selectorWrapper.classList.add(
        "technology-navigator__selector--updating"
      );
      await delay(600);

      // update step index
      document.body.classList.remove(
        "technology-navigator-step-0",
        "technology-navigator-step-1",
        "technology-navigator-step-2",
        "technology-navigator-step-3",
        "technology-navigator-step-4"
      );
      document.body.classList.add(
        "technology-navigator-step-" + this.path.length
      );

      // replace titles
      this.titleElement.innerText = this.titles[Math.min(this.path.length, 3)];
      this.subtitleElement.innerText =
        this.subtitles[Math.min(this.path.length, 3)];

      // get technology options
      const options = this.getTechnologiesOptions();

      const items = Array.from(
        this.selector.querySelectorAll(".technology-navigator__selector-item")
      );

      // replace items
      options.forEach((option, index) => {
        if (index >= items.length) {
          // item doesn't exist, create it
          // using this.selectorItemTemplate as a template

          console.log(this.selectorItemTemplate);
          const clone = this.selectorItemTemplate.cloneNode(true);

          this.selector.appendChild(clone);
          items.push(clone);
        }

        // item exists, update it
        const item = items[index];

        // configure label to radio
        const radio = item.querySelector(
          ".technology-navigator__selector-item-radio"
        );
        radio.checked = false;
        radio.value = option.id;

        // check if change event is already attached
        if (!radio.hasAttribute("data-change-event-attached")) {
          radio.addEventListener("change", this.handleItemRadioChange);
          radio.setAttribute("data-change-event-attached", true);
        }

        const itemId = `technology-navigator__selector-item-radio-${index}`;
        radio.setAttribute("id", itemId);
        item.setAttribute("for", itemId);

        item.querySelector(
          ".technology-navigator__selector-item-title"
        ).innerText = option.title;
      });

      if (items.length > options.length) {
        // remove extra items
        items.slice(options.length).forEach(this.destroyItem);
      }

      // fade in this.selector
      this.ringSelector.classList.remove("technology-ring-selector--updating");
      this.selectorWrapper.classList.remove(
        "technology-navigator__selector--updating"
      );

      this.renderedPath = [...this.path];
      this.selectedItem = null;

      // update progress bar
      if (this.progressBar) {
        const step = Math.min(this.path.length + 1, 4);

        this.progressBar.querySelector(
          ".technology-progress-bar__progress"
        ).style.transform = `scaleX(${step / 4})`;
        this.progressBar.querySelector(
          ".technology-progress-bar__value"
        ).innerText = `${step} / 4`;
      }
    }

    // update path dataset
    // NOTE: this is needed because when navigating back, the path is not
    //       updated, so we need to update it manually via setAttribute
    this.block.setAttribute("data-path", JSON.stringify(this.path));

    // update back button disabled state
    this.selectorBackAction.disabled = !this.path.length;
    this.selectorContinueAction.disabled = !this.selectedItem;
  };

  onReady = () => {
    this.titles = JSON.parse(this.block.dataset.titles);
    this.subtitles = JSON.parse(this.block.dataset.subtitles);
    this.technologies = JSON.parse(this.block.dataset.technologies);
    this.path = JSON.parse(this.block.dataset.path);

    this.links = Array.from(
      this.block.querySelectorAll(".technology-navigator__item-link")
    );
    this.links.forEach((link) => {
      link.addEventListener("click", this.handleLinkClick);
    });

    this.progressBar = this.block
      .closest(".technology-page")
      .querySelector(".technology-progress-bar");

    this.titleElement = this.block.querySelector(
      ".technology-navigator__title"
    );
    this.subtitleElement = this.block.querySelector(
      ".technology-navigator__subtitle"
    );
    this.selectorWrapper = this.block.querySelector(
      ".technology-navigator__selector"
    );
    this.selector = this.selectorWrapper.querySelector(
      ".technology-navigator__selector-inner"
    );
    this.selectorItemTemplate = this.block.querySelector(
      ".technology-navigator__selector-item-template"
    ).content.firstElementChild;
    this.selectorBackAction = this.block.querySelector(
      ".technology-navigator__selector-action--back"
    );
    this.selectorContinueAction = this.block.querySelector(
      ".technology-navigator__selector-action--continue"
    );

    this.ringSelector = this.block.querySelector(".technology-ring-selector");
    this.ringSelectorItems = this.ringSelector.querySelectorAll(
      ".technology-ring-selector .ring-item--first-level"
    );

    this.render();

    this.ringSelectorItems.forEach((i) => {
      i.addEventListener("click", this.handleRingItemClick);
    });

    this.selectorBackAction.addEventListener("click", this.handleBack);
    this.selectorContinueAction.addEventListener("click", this.handleContinue);
  };

  onDestroy = () => {
    const radios = Array.from(document.getElementsByName("technology"));
    radios.forEach((radio) => {
      radio.removeEventListener("change", this.handleItemRadioChange);
    });

    this.links.forEach((link) => {
      link.removeEventListener("click", this.handleLinkClick);
    });

    this.ringSelectorItems.forEach((i) => {
      i.removeEventListener("click", this.handleRingItemClick);
    });

    this.selectorBackAction.removeEventListener("click", this.handleBack);
    this.selectorContinueAction.removeEventListener(
      "click",
      this.handleContinue
    );
  };
}
